/** The glyphs a layer row needs. Inline paths: the design kit ships no icon set. */

const BOX = { viewBox: "0 0 16 16", width: 14, height: 14, "aria-hidden": true } as const;

const STROKE = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  strokeLinejoin: "round",
} as const;

export function EyeIcon() {
  return (
    <svg {...BOX}>
      <path {...STROKE} d="M1 8s2.6-4.2 7-4.2S15 8 15 8s-2.6 4.2-7 4.2S1 8 1 8Z" />
      <circle {...STROKE} cx="8" cy="8" r="1.9" />
    </svg>
  );
}

export function EyeOffIcon() {
  return (
    <svg {...BOX}>
      <path {...STROKE} d="M2.6 4.4C1.5 5.6 1 8 1 8s2.6 4.2 7 4.2c1.2 0 2.2-.3 3.1-.7" />
      <path {...STROKE} d="M6.2 4c.6-.1 1.2-.2 1.8-.2 4.4 0 7 4.2 7 4.2s-.7 1.1-1.9 2.2" />
      <path {...STROKE} d="M2 2l12 12" />
    </svg>
  );
}

export function LockIcon() {
  return (
    <svg {...BOX}>
      <rect {...STROKE} x="3.2" y="7" width="9.6" height="6.4" rx="1.2" />
      <path {...STROKE} d="M5.6 7V5.2a2.4 2.4 0 0 1 4.8 0V7" />
    </svg>
  );
}

export function UnlockIcon() {
  return (
    <svg {...BOX}>
      <rect {...STROKE} x="3.2" y="7" width="9.6" height="6.4" rx="1.2" />
      <path {...STROKE} d="M5.6 7V5.2a2.4 2.4 0 0 1 4.6-.8" />
    </svg>
  );
}

export function UpIcon() {
  return (
    <svg {...BOX}>
      <path {...STROKE} d="M8 12.5V3.5M4 7l4-3.5L12 7" />
    </svg>
  );
}

export function DownIcon() {
  return (
    <svg {...BOX}>
      <path {...STROKE} d="M8 3.5v9M4 9l4 3.5L12 9" />
    </svg>
  );
}

export function PointerIcon() {
  return (
    <svg {...BOX}>
      <path {...STROKE} d="M3.5 2.2 12.4 8l-3.6.9-1.7 3.5L3.5 2.2Z" />
    </svg>
  );
}

export function MoveIcon() {
  return (
    <svg {...BOX}>
      <path {...STROKE} d="M8 2v12M2 8h12M8 2 6.2 4M8 2l1.8 2M8 14l-1.8-2M8 14l1.8-2" />
      <path {...STROKE} d="M2 8l2-1.8M2 8l2 1.8M14 8l-2-1.8M14 8l-2 1.8" />
    </svg>
  );
}
